import { DisplayProperties } from '@com-delta-omnichannel/aura';
import { AEMErrorMessage } from '../models';
import { checkErrors, getEmptyContent } from '../utils';

export const getFullPageError = (
  errors: (string | undefined)[],
  errorMessagesMocks: AEMErrorMessage[]
): DisplayProperties => {
  if (checkErrors(errors, errorMessagesMocks)) {
    return getEmptyContent<DisplayProperties>(
      'full-page',
      errorMessagesMocks,
      true
    );
  }
  return getEmptyContent<DisplayProperties>();
};
